<template>
  <div class="section1">
    <div class="logo">
      <img :src="logoImg" alt="" />
    </div>
    <nav-menu @click="handleClick"></nav-menu>
    <swiper></swiper>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
import Swiper from "./components/Swiper.vue";

export default {
  components: {
    Swiper,
    NavMenu,
  },
  data() {
    return {
      logoImg: require("../../assets/home/logo.png"),
    };
  },
  methods: {
    handleClick() {
      this.$emit("open");
    },
  },
};
</script>

<style lang="less" scoped>
.section1 {
  height: 100%;
  position: relative;
  color: #fff;
  .logo {
    width: 200px;
    height: 34px;
    left: 1.5rem;
    top: 1.8rem;
    z-index: 2022;
    position: absolute;
  }
}
</style>
